export const VENDORSETUP_GRID_LOADING = 'VENDORSETUP_GRID_LOADING';
export const VENDORSETUP_GET = 'VENDORSETUP_GET';
export const VENDORSETUP_GET_ERROR = 'VENDORSETUP_GET_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/page/types.js